import { Reveal } from "./Reveal";
import { useT } from "@/i18n";

const STUDIO_URL = "https://www.studioprojectworks.com";

export const Manifesto = () => {
  const t = useT().manifesto;

  return (
    <section id="studio" className="bg-pine text-bone" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1440px] px-6 py-28 lg:px-12 lg:py-44">
        <Reveal>
          <p className="mb-4 text-[11px] uppercase tracking-[0.35em] text-bone/50" data-testid="manifesto-kicker">{t.kicker}</p>
          <h2 className="max-w-3xl font-serif text-4xl tracking-tight sm:text-5xl" data-testid="manifesto-heading">
            <a
              href={STUDIO_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="manifesto-studio-link"
              className="underline decoration-terra/70 decoration-2 underline-offset-8 transition-colors duration-300 hover:text-terra"
            >
              {t.headingLink}
            </a>
            {t.headingRest}
          </h2>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-bone/70 md:text-lg" data-testid="manifesto-intro">
            {t.intro}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <a
            href={STUDIO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="manifesto-studio-cta"
            className="group mt-10 inline-flex items-center gap-3 bg-terra px-8 py-4 text-xs uppercase tracking-[0.22em] text-bone transition-colors duration-300 hover:bg-bone hover:text-ink"
          >
            {t.badgeCta}
            <span className="transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true">↗</span>
          </a>
        </Reveal>
      </div>
    </section>
  );
};
